import moment from 'moment';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

type Props = {
  savedAt: number | null;
  showImageNote?: boolean;
  onDiscard: () => void;
  onDismiss: () => void;
};

const DraftRestoredBanner = ({ savedAt, showImageNote, onDiscard, onDismiss }: Props) => {
  const relativeTime = savedAt ? moment(savedAt).fromNow() : 'an earlier session';
  return (
    <Alert
      severity="info"
      onClose={onDismiss}
      sx={{ mb: 2 }}
      action={(
        <Stack direction="row" spacing={1} alignItems="center">
          <Button color="inherit" size="small" onClick={onDiscard}>
            Discard and start fresh
          </Button>
        </Stack>
      )}
    >
      Restored an unsaved draft from {relativeTime}.
      {showImageNote && ' (Image upload not restored — re-attach if needed.)'}
    </Alert>
  );
};

export default DraftRestoredBanner;
